import { render, staticRenderFns } from "./distributionStat.vue?vue&type=template&id=54615f0e&"
import script from "./distributionStat.vue?vue&type=script&lang=js&"
export * from "./distributionStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports